import React, { useEffect, useState } from 'react';

import {
  Loader,
  RadioGroup,
  Conditional,
  Text,
  List,
} from '@cashfree-intl/coherent';

import ActionModal from 'components/ActionModal';

// Constants
import { UPDATE_PAYOUT_OPTIONS } from '../constants';

// Types
import { PayoutAccountDataType, UpdatePayoutsModalProps } from '../types';

// Styled
import { StyledPayoutListSection } from '../styled';
import { StyledCheckbox } from 'styles/styledComponents/common';

const UpdatePayoutsModal = ({
  onClose,
  onSubmit,
  payoutBankAccounts,
  isModalLoading,
}: UpdatePayoutsModalProps) => {
  const [selected, setSelected] = useState('false');
  const [payoutIds, setPayoutIds] = useState([]);

  const showPayoutsDropdown =
    selected === 'true' && payoutBankAccounts.length > 1;
  const handleOptionalRadioOptions = obj => ({
    ...obj,
    checked: selected === obj.value,
  });

  const onCheckboxChange = (item: PayoutAccountDataType) => () => {
    if (payoutIds.includes(item.accountId)) {
      setPayoutIds(payoutIds.filter(id => id !== item.accountId));
    } else {
      setPayoutIds([...payoutIds, item.accountId]);
    }
  };

  const onChange = (_, obj) => {
    setSelected(obj.value);
  };

  const submitHandler = () => {
    onSubmit(payoutIds, selected === 'true');
  };

  useEffect(() => {
    if (payoutBankAccounts.length === 1)
      setPayoutIds([payoutBankAccounts[0].accountId]);
    else setPayoutIds([]);
  }, [payoutBankAccounts]);

  return (
    <ActionModal
      onClose={onClose}
      onConfirm={submitHandler}
      title="Do you want to whitelist the bank details
      for Payouts as well?"
      confirmText="Confirm & update"
      data-testid="update-payouts-modal"
    >
      <Loader active={isModalLoading} />
      <RadioGroup
        fieldLabel=""
        onChange={onChange}
        radioOptions={UPDATE_PAYOUT_OPTIONS.map(handleOptionalRadioOptions)}
        direction="column"
      />
      <Conditional if={showPayoutsDropdown}>
        <StyledPayoutListSection direction="column" className="ml-3 mt-1">
          <Text variant="h16" strong>
            Choose accounts to update this change
          </Text>
          <List>
            {payoutBankAccounts.map(item => (
              <List.Item key={item.accountId}>
                <StyledCheckbox
                  label={item.accountName}
                  key={item.accountId}
                  name={item.accountName}
                  checked={payoutIds.includes(item.accountId)}
                  onChange={onCheckboxChange(item)}
                  $minHeight="unset"
                  className="mb-2"
                />
              </List.Item>
            ))}
          </List>
        </StyledPayoutListSection>
      </Conditional>
    </ActionModal>
  );
};

export default UpdatePayoutsModal;
